<template>
  <div class="flex h-screen bg-gray-100">
    <!-- Sidebar -->
    <RoleSidebar />

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Header -->
      <header class="bg-white shadow-md p-4 flex justify-between items-center">
        <h2 class="text-xl font-semibold text-gray-800">
          {{ $route.meta.title || 'Shop Management' }}
        </h2>
        <div class="text-gray-600">
          Date: {{ currentDate }} | Time: {{ currentTime }}
        </div>
      </header>

      <!-- Main Content -->
      <main class="flex-1 overflow-y-auto p-6">
        <router-view />
      </main>

      <!-- Footer (Optional) -->
      <footer class="bg-white shadow-inner p-4 text-center text-gray-600 text-sm">
        &copy; {{ currentYear }} StockFlow. All rights reserved.
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import RoleSidebar from '@/components/RoleSidebar.vue'

const route = useRoute()
const currentDate = computed(() => new Date().toLocaleDateString('en-US', { dateStyle: 'medium' }))
const currentTime = computed(() => new Date().toLocaleTimeString('en-US', { timeStyle: 'short' }))
const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
/* Ensure full height and smooth transitions */
html, body {
  height: 100%;
  margin: 0;
}

.flex-1 {
  min-height: 0; /* Prevent overflow issues */
}

.overflow-y-auto {
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on mobile */
}
</style>